// extracted by mini-css-extract-plugin
export default {"container":"status-picker-module__container--rQosG"};